import { gql } from 'graphql-request';

const STORE_LOCATION_COLLECTION = gql`
  query storeLandingPage(
    $locale: String!
    $order: [StoreLocationOrder]
    $where: StoreLocationFilter
  ) {
    storeLocationCollection(locale: $locale, order: $order, where: $where) {
      total
      items {
        sys {
          id
        }
        enabled
        storeName
        googleMapsUrl
        handle
        streetAddress
        storeDescription
        seoStoreDescription
        city
        stateProvince
        countryRegion
        zipPostalCode
        storeHours
        phoneNumber
        featuredImage {
          sys {
            id
          }
          title
          url
          width
          height
        }
        servicesV2Collection {
          items {
            label
          }
        }
        geoLocation {
          lat
          lon
        }
      }
    }
  }
`;

const CONTENTFUL_OPERATIONS = {
  STORE_LOCATION_COLLECTION: 'storeLocationCollection',
};

const CONTENTFUL_QUERIES = {
  STORE_LOCATION_COLLECTION,
};

const CONTENTFUL_PARAMS = {
  ORDER_SORT_NAME_ASC: 'storeName_ASC',
};

export { CONTENTFUL_OPERATIONS, CONTENTFUL_QUERIES, CONTENTFUL_PARAMS };
